import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import moment from 'moment';

import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestClients } from '../../../store/client-manager/ClientManagerActions';
import LocationForm from '../components/location/LocationForm';
import {
  requestLocationDetails,
  updateLocationDetails,
  requestActivityStatuses,
  requestTeamNames,
} from '../../../store/location-manager/LocationManagerActions';
import { hostTitle } from '../../../config/ui';

class LocationEdit extends React.Component {
  componentWillMount() {
    const { getLocation, getActivityStatuses, getTeamNames } = this.props;

    getLocation(this.props.params.clinicLocationID, {
      tenantId: this.props.tenantId,
    });
    getActivityStatuses({
      tenantId: this.props.tenantId,
    });
    getTeamNames({
      tenantId: this.props.tenantId,
    });
  }

  onSubmit = (values) => {
    this.props
      .updateLocation(values, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Location has been saved.');
          hashHistory.push('/location-manager/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/location-manager/');
  };

  getDetails = () => {
    const {
      data: { details },
      params: { clinicLocationID },
    } = this.props;
    if (clinicLocationID === '0' && details[clinicLocationID]) {
      details[clinicLocationID]['startDate'] = moment().format(
        'YYYY-MM-DDThh:mm:ss',
      );
      details[clinicLocationID]['DPC'] = 'Y';
      details[clinicLocationID]['reciprocityAgreements'] = 'Y';
      details[clinicLocationID]['isShared'] = 'Y';
    }
    return details[clinicLocationID] ? details[clinicLocationID] : {};
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              id: item.id,
              lastName: item.lastName,
              firstName: item.firstName,
            }),
          );
        }
        return options;
      });
  };

  searchClients = (search, filters = '') => {
    return this.props
      .getClients({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters: null,
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) =>
            options.push({
              employerCodeNumber: item.employerCodeNumber,
              employerCodeDescription: item.employerCodeDescription,
              name: `${item.employerCodeDescription} (${item.employerCodeNumber})`,
            }),
          );
        }
        return options;
      });
  };

  render() {
    const {
      data: {
        location,
        details,
        isLoading,
        isUpdating,
        teamNames,
        isTeamNamesLoading,
        activityStatuses,
        isActivityStatusesLoading,
      },
      params: { clinicLocationID },
    } = this.props;

    return (
      <div id="content">
        {location.clinicLocationID && (
          <Helmet title={`${location.clinicLocationID} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Location Manager', route: '/location-manager' },
            'Location',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>
                {details[clinicLocationID] && `Edit Location `}
                {details[clinicLocationID] && <i>({clinicLocationID})</i>}
                {!details[clinicLocationID] && `Add Location `}
              </h2>
            </header>
            <div>
              <div className="widget-body">
                {
                  <LocationForm
                    isLoading={
                      isLoading ||
                      isUpdating ||
                      isTeamNamesLoading ||
                      isActivityStatusesLoading
                    }
                    teamNames={teamNames}
                    activityStatuses={activityStatuses}
                    onSubmit={this.onSubmit}
                    initialValues={this.getDetails()}
                    searchUsers={this.searchUsers}
                    searchClients={this.searchClients}
                    onCancel={this.onCancel}
                  />
                }
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.locationmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getLocation: (clinicLocationID, params) =>
      dispatch(requestLocationDetails(clinicLocationID, params)),
    updateLocation: (location, params) =>
      dispatch(updateLocationDetails(location, params)),
    getActivityStatuses: (params) => dispatch(requestActivityStatuses(params)),
    getTeamNames: (params) => dispatch(requestTeamNames(params)),
    getClients: (params) => dispatch(requestClients(params)),
  }),
)(LocationEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/LocationEdit.js